/**
 * Deep-merges Orbex-owned locale catalogs into the upstream vue-i18n `messages`
 * object.
 *
 * Only the locales present in `overrides` are touched, so every other language
 * keeps the upstream catalog by identity. Within a merged locale, upstream keys
 * that the override does not mention are preserved, which keeps vue-i18n's
 * normal fallback behaviour intact for anything Orbex does not own.
 */

const isPlainObject = value =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const deepMerge = (base, override) => {
  if (!isPlainObject(base)) return override;
  if (!isPlainObject(override)) return override;

  const merged = { ...base };

  Object.keys(override).forEach(key => {
    merged[key] = isPlainObject(base[key])
      ? deepMerge(base[key], override[key])
      : override[key];
  });

  return merged;
};

export const mergeLocaleMessages = (messages, overrides) => {
  if (!isPlainObject(overrides)) return messages;

  const merged = { ...messages };

  Object.keys(overrides).forEach(locale => {
    merged[locale] = deepMerge(messages[locale] ?? {}, overrides[locale]);
  });

  return merged;
};
